import http from "@/core/services/http.service";

const VendorChargesService = {
  getVendorCharges(params = null) {
    return http.get('/api/v1/vendor-charges/', {params});
  },
  addOrUpdateVendorCharge(params) {
    return http.post('/api/v1/vendor-charges/', params);
  },
  removeCharge(uuid) {
    return http.delete(`/api/v1/vendor-charges/${uuid}`);
  },
  checkUsed(params) {
    return http.get('/api/v1/vendor-charges/check-used/', {params});
  },
  batchDeactivate(ids) {
    return http.post('/api/v1/vendor-charges/batch-deactivate/', ids);
  },
  batchDelete(ids) {
    return http.post('/api/v1/vendor-charges/batch-delete/', ids);
  }
};

export default VendorChargesService;
